@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.ervasstudio.tracoemovimento.components.layouts.PageLayout as _com_ervasstudio_tracoemovimento_components_layouts_PageLayout
import com.ervasstudio.tracoemovimento.pages.HomePage as _com_ervasstudio_tracoemovimento_pages_HomePage
import com.ervasstudio.tracoemovimento.pages.blog.BlogPage as _com_ervasstudio_tracoemovimento_pages_blog_BlogPage
import com.ervasstudio.tracoemovimento.pages.cursos.CursosPage as _com_ervasstudio_tracoemovimento_pages_cursos_CursosPage
import com.ervasstudio.tracoemovimento.pages.cursos.login.LoginPage as _com_ervasstudio_tracoemovimento_pages_cursos_login_LoginPage
import com.ervasstudio.tracoemovimento.pages.cursos.meuscursos.MeusCursos as _com_ervasstudio_tracoemovimento_pages_cursos_meuscursos_MeusCursos
import com.ervasstudio.tracoemovimento.pages.cursos.signup.Signup as _com_ervasstudio_tracoemovimento_pages_cursos_signup_Signup
import com.ervasstudio.tracoemovimento.pages.projecto.ProjectoPage as _com_ervasstudio_tracoemovimento_pages_projecto_ProjectoPage
import com.ervasstudio.tracoemovimento.pages.sobre.SobrePage as _com_ervasstudio_tracoemovimento_pages_sobre_SobrePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Tracoemovimento"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_ervasstudio_tracoemovimento_components_layouts_PageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx -> 
            _com_ervasstudio_tracoemovimento_pages_HomePage()
        }
        ctx.router.register(
            "/blog/{id?}",
            layoutId = "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx -> 
            _com_ervasstudio_tracoemovimento_pages_blog_BlogPage()
        }
        ctx.router.register(
            "/cursos/",
            layoutId = "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx -> 
            _com_ervasstudio_tracoemovimento_pages_cursos_CursosPage()
        }
        ctx.router.register(
            "/cursos/login/",
            layoutId = "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx -> 
            _com_ervasstudio_tracoemovimento_pages_cursos_login_LoginPage()
        }
        ctx.router.register(
            "/cursos/meuscursos/",
            layoutId = "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx -> 
            _com_ervasstudio_tracoemovimento_pages_cursos_meuscursos_MeusCursos()
        }
        ctx.router.register(
            "/cursos/signup/",
            layoutId = "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx -> 
            _com_ervasstudio_tracoemovimento_pages_cursos_signup_Signup()
        }
        ctx.router.register(
            "/projecto/",
            layoutId = "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx -> 
            _com_ervasstudio_tracoemovimento_pages_projecto_ProjectoPage()
        }
        ctx.router.register(
            "/sobre/",
            layoutId = "com.ervasstudio.tracoemovimento.components.layouts.PageLayout",
        ) { pageCtx -> 
            _com_ervasstudio_tracoemovimento_pages_sobre_SobrePage()
        }

        com.ervasstudio.tracoemovimento.initFirebase(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("team-card", com.ervasstudio.tracoemovimento.style.TeamCardStyle)
        ctx.theme.registerStyle("overlay", com.ervasstudio.tracoemovimento.style.OverlayStyle)
        ctx.theme.registerKeyframes("move-diagonal", com.ervasstudio.tracoemovimento.style.MoveDiagonal)
        ctx.theme.registerKeyframes("diagonal-movement", com.ervasstudio.tracoemovimento.style.DiagonalMovement)
        ctx.theme.registerKeyframes("rotate-loop", com.ervasstudio.tracoemovimento.style.RotateLoop)
        com.ervasstudio.tracoemovimento.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.ervasstudio.tracoemovimento.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
